<template>
  <div>
    <v-menu bottom min-width="200px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-avatar size="48">
            <v-icon>mdi-account</v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-card>
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-center">
            <v-avatar>
              <v-icon>mdi-account</v-icon>
            </v-avatar>
            <h3>{{ userData.userLoginId }}</h3>
            <p class="text-caption mt-1">
              {{ userData.emailId }}
            </p>
            <v-btn depressed rounded text @click="viewProfile">
              View Profile
            </v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn depressed rounded text @click="handleLogout">
              Logout
            </v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "userProfile",
  components: {},
  data() {
    return {
      modalConfig: {
        enabled: false,
        persistent: true,
        saveButton: "yes",
        cancelButton: "no",
        title: "confirm",
        width: 450,
      },
      modalContent: "logout",
      userData: {
        userLoginId: "User",
        emailId: "user@finastra.com",
      },
    };
  },
  methods: {
    handleLogout() {
      this.$router.push({name: 'Login'})
    },
    viewProfile() {
      this.$router.push({name: 'Profile'})
    }
  },
};
</script>
